/* ss-judgeme.js - kjorer overalt der Judge.me-widgeten finnes.
   Laa tidligere inne i sections/ss-reviews-summary.liquid, som bare rendres paa
   produktmaler. Kolleksjonssidene (kalis-collection-reviews.liquid) fikk da CSS-en
   fra theme.liquid men ikke JS-en: gridet sto i auto-fallback uten masonry,
   pilknappen var tom (ikonet skjult av CSS, teksten settes her) og snitt-tallet
   manglet. Lastes naa fra theme.liquid rett etter ss-judgeme.css.
   Seksjonen rendrer bare AI-kortets kilde (#ss-ai-source); dette skriptet finner
   den om den er der. */
(function(){
  var IMG_W = 640;

  /* 1) snitt-tall ved stjernene: 4.96 -> 4.9 (rundes ned, som dummy) */
  function avg(){
    var st = document.querySelector('.jdgm-rev-widg__summary-stars');
    if(!st || st.dataset.ssAvg) return;
    var m = (st.getAttribute('aria-label')||'').match(/([0-9]+[.,][0-9]+)/);
    if(!m) return;
    var s = document.createElement('span');
    s.className = 'ss-jdgm-avg';
    s.textContent = (Math.floor(parseFloat(m[1].replace(',','.'))*10)/10).toFixed(1);
    if(st.parentNode) st.parentNode.insertBefore(s, st.nextSibling); else st.appendChild(s);
    st.dataset.ssAvg = '1';
  }

  /* 2) AI-kortet flyttes inn i widgeten, rett UNDER skriv-knappen.
        Judge.me bygger .jdgm-rev-widg__body helt paa nytt ved paginering,
        og da forsvinner kortet med den gamle DOM-en. Derfor beholdes en
        kopi i ssAiCard, og kortet settes inn paa nytt hver gang det mangler
        - i stedet for aa fjerne kilden som forste versjon gjorde. */
  var ssAiCard = null;
  function moveAi(){
    /* 18.09.2026 (Kristoffer): AI-sammendraget hoerer bare til produktsiden - ikke widgeten nederst paa kolleksjonssidene */
    if(!document.body.classList.contains('template-product')) return;
    if(!ssAiCard){
      var src = document.getElementById('ss-ai-source');
      var found = src && src.querySelector('.ss-aisum');
      if(found) ssAiCard = found.cloneNode(true);
    }
    if(!ssAiCard) return;
    if(document.querySelector('.jdgm-rev-widg__moved-ai .ss-aisum')) return;
    /* Kortet legges i HEADER, rett etter stjerner/knapp (.jdgm-row-stars).
       Header overlever sidebytte; body bygges paa nytt av Judge.me, og laa
       kortet der forsvant det under lasting og spinneren krop opp under knappen.
       Fallback til body hvis header mangler. */
    var stars = document.querySelector('.jdgm-rev-widg__header .jdgm-row-stars');
    var head = document.querySelector('.jdgm-rev-widg__header');
    var body = document.querySelector('.jdgm-rev-widg__body');
    if(!head && !body) return;
    var stale = document.querySelector('.jdgm-rev-widg__moved-ai');
    if(stale) stale.remove();
    var wrap = document.createElement('div');
    wrap.className = 'jdgm-rev-widg__moved-ai';
    wrap.appendChild(ssAiCard.cloneNode(true));
    if(stars && stars.parentNode === head) head.insertBefore(wrap, stars.nextSibling);
    else if(head) head.appendChild(wrap);
    else body.insertBefore(wrap, body.firstChild);
  }

  /* 2b) 17.09.2026 (Kristoffer) - header v2. Over kortene: en rad med AI-kortet og histogrammet side om side
        (.ss-rev-top; histogrammet finnes bare naar det er slaatt paa i Judge.me-admin, og skjules paa mobil av CSS),
        og en verktoyrad (.ss-rev-tools) med sorteringsvelgeren til venstre og «Skriv en anmeldelse» til hoyre.
        Alt ligger i header, som overlever Judge.mes ombygging av body ved paginering/sortering. Idempotent:
        elementene flyttes bare naar de ikke alt staar der. */
  function headerV2(){
    var head = document.querySelector('.jdgm-rev-widg__header'); if(!head) return;
    var ai = head.querySelector('.jdgm-rev-widg__moved-ai');
    /* bare et histogram MED rader - Judge.me rendrer tomme .jdgm-histogram-beholdere naar det er slaatt av */
    var hist = document.querySelector('.jdgm-rev-widg .jdgm-histogram'); if(hist && !hist.querySelector('.jdgm-histogram__row')) hist = null;
    var top = head.querySelector('.ss-rev-top');
    if(ai || hist){
      if(!top){ top = document.createElement('div'); top.className = 'ss-rev-top';
        var anchor = ai || head.querySelector('.jdgm-row-stars');
        if(anchor && anchor.parentNode === head) head.insertBefore(top, anchor.nextSibling); else head.appendChild(top); }
      if(ai && ai.parentNode !== top) top.appendChild(ai);
      if(hist && hist.parentNode !== top){ var hb = document.createElement('div'); hb.className = 'ss-rev-hist'; hb.appendChild(hist); top.appendChild(hb); }
      /* Judge.me kan fjerne histogram-noden igjen ved ombygging - da skal ikke det hvite kortet staa tomt */
      [].forEach.call(top.querySelectorAll('.ss-rev-hist'), function(hb){ if(!hb.querySelector('.jdgm-histogram__row')) hb.remove(); });
      top.classList.toggle('ss-rev-top--two', !!(ai && top.querySelector('.ss-rev-hist')));
    }
    /* 18.09 kveld: staar .ss-rev-top igjen uten innhold (kolleksjonssidene: ingen AI, histogram fjernet av Judge.me), bort med den - ellers 24px tom luft */
    if(top && !top.querySelector('.ss-aisum, .ss-rev-hist')) { top.remove(); top = null; }
    var sort = document.querySelector('.jdgm-rev-widg .jdgm-rev-widg__sort-wrapper');
    var write = document.querySelector('.jdgm-rev-widg .jdgm-widget-actions-wrapper') || document.querySelector('.jdgm-rev-widg .jdgm-write-rev-link');
    if(!sort && !write) return;
    var tools = head.querySelector('.ss-rev-tools');
    if(!tools){ tools = document.createElement('div'); tools.className = 'ss-rev-tools'; head.appendChild(tools); }
    if(head.lastElementChild !== tools) head.appendChild(tools);   /* alltid nederst i header = rett over kortene */
    if(sort && sort.parentNode !== tools) tools.appendChild(sort);
    if(write && write.parentNode !== tools) tools.appendChild(write);
    /* lenketeksten er satt i STORE BOKSTAVER i Judge.me-admin («SKRIV EN ANMELDELSE») - som lenke skal den staa som setning */
    var link = tools.querySelector('.jdgm-write-rev-link');
    /* ingen engangs-flagg: Judge.me setter foerst «Write a review» og oversetter etterpaa - sjekken er idempotent (en setning er ikke lenger bare store bokstaver) */
    if(link){ var s = link.textContent.trim(); if(s && s === s.toUpperCase() && s !== s.toLowerCase()){ link.textContent = s.charAt(0) + s.slice(1).toLowerCase(); } }
  }

  /* 3b) 18.09.2026 - lastetid. Judge.me leverer widget-HTML paa ENGELSK og oversetter foerst naar deres skript har kjoert (~2,3 s),
        bygger sorteringsvelgeren ved ~2,9 s og starter bildelastingen etter det. Alt dette kan vi gjoere med en gang, fordi
        de oversatte tekstene ligger i window.jdgmSettings i <head> fra start, og bildene har data-src fra start.
        i18n(): tittel, «Basert paa N anmeldelser» og «Skriv en anmeldelse» (fra locales via #ss-jdgm-config[data-ss-write])
        sortPlaceholder(): pill med standardsorteringens tekst til Judge.mes <select> kommer, saa raden ikke hopper
        eagerImgs(): src = data-src i kortets bredde x DPR (samme URL som Judge.me selv ber om), loading=lazy */
  function i18n(){
    var S = window.jdgmSettings || {};
    var w = document.querySelector('.jdgm-rev-widg'); if(!w) return;
    var t = w.querySelector('.jdgm-rev-widg__title');
    if(t && S.widget_title && /^\s*Customer Reviews\s*$/i.test(t.textContent)) t.textContent = S.widget_title;
    var st = w.querySelector('.jdgm-rev-widg__summary-text');
    if(st && S.widget_summary_text && /Based on/i.test(st.textContent) && st.children.length === 0){
      var n = parseInt(w.getAttribute('data-number-of-reviews') || '', 10);
      if(!isNaN(n)) st.textContent = S.widget_summary_text.replace(/\{\{\s*number_of_reviews\s*\}\}/g, nf.format(n));
    }
    var cfg = document.getElementById('ss-jdgm-config'); var wt = cfg && cfg.getAttribute('data-ss-write');
    if(wt && /translation missing/i.test(wt)) wt = null; /* butikker uten ss.reviews.write i locales ennaa - la Judge.mes egen tekst staa */
    /* 18.09 kveld: kolleksjonssidenes widget har ikke #ss-jdgm-config (bare produktmalen rendrer ss-reviews-summary) - bruk Judge.mes egen
       oversatte tekst fra jdgmSettings (STORE BOKSTAVER i admin; headerV2 gjoer den om til setning) i stedet for aa la «Write a review» staa */
    if(!wt && S.widget_open_form_text) wt = S.widget_open_form_text;
    var link = w.querySelector('.jdgm-write-rev-link');
    if(link && wt && /^\s*Write a review\s*$/i.test(link.textContent)) link.textContent = wt;
  }
  /* 18.09.2026 (Kristoffer, variant A): produkt uten anmeldelser. Judge.me viser «0.0/5», tomme stjerner, «Vær den første …»,
        sorteringsvelger og en understreket lenke. I stedet: tittel, én linje («Ingen anmeldelser enda», locales ss.reviews.none via
        #ss-jdgm-config[data-ss-none], fallback Judge.mes badge_no_review_text) og «Skriv en anmeldelse» som pill, sentrert. CSS: .ss-rev--empty */
  function emptyState(){
    var w = document.querySelector('.jdgm-rev-widg'); if(!w) return;
    if(w.getAttribute('data-number-of-reviews') !== '0'){ w.classList.remove('ss-rev--empty'); return; }
    w.classList.add('ss-rev--empty');
    var head = w.querySelector('.jdgm-rev-widg__header'); if(!head || head.querySelector('.ss-rev-empty')) return;
    var cfg = document.getElementById('ss-jdgm-config'); var txt = cfg && cfg.getAttribute('data-ss-none');
    if(!txt || /translation missing/i.test(txt)) txt = (window.jdgmSettings && jdgmSettings.badge_no_review_text) || '';
    if(!txt) return;
    var p = document.createElement('p'); p.className = 'ss-rev-empty'; p.textContent = txt;
    var title = head.querySelector('.jdgm-rev-widg__title');
    if(title && title.parentNode === head) head.insertBefore(p, title.nextSibling); else head.insertBefore(p, head.firstChild);
  }
  function sortPlaceholder(){
    var S = window.jdgmSettings || {};
    var tools = document.querySelector('.ss-rev-tools'); if(!tools) return;
    var wrap = tools.querySelector('.jdgm-rev-widg__sort-wrapper');
    var ph = tools.querySelector('.ss-rev-sort-ph');
    var hasSelect = wrap && wrap.querySelector('select');
    if(hasSelect){ if(ph) ph.remove(); return; }
    if(ph) return;
    var key = 'widget_sorting_' + String(S.default_sort_method || 'most-recent').replace(/-/g, '_') + '_text';
    var label = S[key]; if(!label) return;
    ph = document.createElement('span'); ph.className = 'ss-rev-sort-ph'; ph.setAttribute('aria-hidden', 'true'); ph.textContent = label;
    if(wrap) wrap.appendChild(ph); else tools.insertBefore(ph, tools.firstChild);
  }
  function eagerImgs(){
    var dpr = Math.min(3, window.devicePixelRatio || 1);
    [].forEach.call(document.querySelectorAll('.jdgm-rev__pics .jdgm-rev__pic-link:first-child .jdgm-rev__pic-img[data-src]:not([src])'), function(img){
      var card = img.closest('.jdgm-rev'); var cw = card ? card.clientWidth : 0; if(!cw) return;
      var w = Math.ceil(cw * dpr);
      var u = img.getAttribute('data-src').replace(/width=\d+/, 'width=' + w);
      img.setAttribute('data-src', u); img.setAttribute('loading', 'lazy'); img.setAttribute('decoding', 'async'); img.src = u; img.dataset.ssHi = '1';
    });
  }
  /* 3) bildene: Judge.me laster width=114 og strekker dem. Bytt til 640. */
  function upgradeImgs(){
    /* bare hovedbildet - miniatyrene bilde 2+ vises i 48px og skal ikke
       lastes i 640px. */
    document.querySelectorAll('.jdgm-rev__pics .jdgm-rev__pic-link:first-child .jdgm-rev__pic-img').forEach(function(img){
      if(img.dataset.ssHi) return;
      ['src','data-src'].forEach(function(attr){
        var v = img.getAttribute(attr);
        if(v && /width=\d+/.test(v)) img.setAttribute(attr, v.replace(/width=\d+/, 'width=' + IMG_W));
      });
      if(img.srcset) img.srcset = img.srcset.replace(/width=\d+/g, 'width=' + IMG_W);
      img.dataset.ssHi = '1';
    });
  }

  /* 4) full tekst - ingen "Read more". Guard: Judge.me kan legge klassen tilbake,
        og uten dataset-flagget her ville observeren under gaa i evig loop. */
  /* TO flagg, med vilje:
       data-ss-seen  settes ALLTID, forste gang vi roerer kortet. Uten det
                     ville et kort som fortsatt er avkuttet blitt behandlet paa
                     nytt ved hver observer-kjoring - og siden vi endrer style,
                     trigger vi observeren selv. Evig lokke, siden fryser.
                     Det var nettopp det som brakk pagineringen 09.09.
       data-ss-full  settes bare naar hele teksten faktisk er synlig, og er det
                     CSS-en bruker for aa skjule «Les mer». Et kort vi ikke fikk
                     apnet beholder dermed en fungerende knapp. */
  function untruncate(){
    document.querySelectorAll('.jdgm-rev__body').forEach(function(b){
      if(b.dataset.ssSeen) return;
      b.dataset.ssSeen = '1';
      b.classList.remove('is-truncated');
      b.style.maxHeight = 'none';
      b.style.overflow = 'visible';
      if(b.scrollHeight <= b.clientHeight + 2) b.dataset.ssFull = '1';
    });
  }


  /* 5) tusenskille i antallstekstene. Judge.me skriver raa siffer:
        "(5195 reviews)". Tallene kommer fra deres egne maler
        (widget_summary_text, subtab-etikettene), som ikke har tallformatering,
        og CSS kan ikke omformatere tekst - saa det maa skje her.
        SCOPING ER VIKTIG: bare summary-teksten og subtab-etikettene roeres.
        Tidsstempler ("02/08/2026") har ogsaa 4-sifrede lop og maa ikke treffes,
        derfor gaas det aldri gjennom et helt anmeldelseskort.
        Idempotent: etter gruppering skilles sifrene av et tegn, saa de matcher
        ikke lenger 4+ sammenhengende siffer og en ny kjoring gjor ingenting. */
  var NUM_SEL = '.jdgm-rev-widg__summary-text, .jdgm-all-reviews__summary-text,'
              + ' .jdgm-subtab__name, .jdgm-histogram__percentage,'
              + ' .jdgm-prev-badge__text'; /* 14.09.2026: badge-teksten («2366 anmeldelser») over tittelen og paa kortene */
  var nf;
  try { nf = new Intl.NumberFormat(document.documentElement.lang || 'en'); }
  catch(e) { nf = new Intl.NumberFormat('en'); }
  function numbers(){
    document.querySelectorAll(NUM_SEL).forEach(function(el){
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), node;
      while((node = walker.nextNode())){
        var before = node.nodeValue;
        if(!/\d{4}/.test(before)) continue;
        var after = before.replace(/\d{4,}/g, function(d){ return nf.format(parseInt(d, 10)); });
        if(after !== before) node.nodeValue = after;
      }
    });
  }

  /* 6) paginering. 19.09.2026 (Kristoffer): vindu paa +-1 rundt gjeldende side, alltid side 1 og siste side, ellipse i gapene:
        side 1: «1 2 3 … 124 ›»   side 10: «‹ 1 … 9 10 11 … 124 ›»   siste: «‹ 1 … 122 123 124».
        Judge.me rendrer +-2 sider som tallknapper (av og til flere) og foerste/siste side som talloese ikonknapper. Vi skjuler det
        som ligger utenfor vinduet (.ss-hide), setter tall paa ytterpunktene og legger inn ellipser. Siste side mangler fra Judge.me
        naar settet har over 100 sider (API-et svarer med side 100 paa alt over): da lages knappen selv som jQuery-kopi
        (clone(true) beholder klikk-handleren) av en tallknapp, for side min(antall/perPage, 100). Kjoerer med observeren frakoblet. */
  function paginate(){
    var pag = document.querySelector('.jdgm-paginate'); if(!pag) return;
    var $ = window.jdgm && jdgm.$;
    [].forEach.call(pag.querySelectorAll('.ss-ellipsis, .ss-synth'), function(e){ e.remove(); });
    var pages = [], byNum = {}, cur = NaN;
    [].forEach.call(pag.querySelectorAll('.jdgm-paginate__page'), function(p){
      var c = p.className;
      if(/next-page|prev-page|last-page|first-page/.test(c)) return;
      var n = parseInt(p.dataset.page, 10); if(isNaN(n)) return;
      pages.push(n); byNum[n] = p; if(/jdgm-curt/.test(c)) cur = n;
    });
    if(!pages.length) return;
    pages.sort(function(a,b){ return a - b; });
    if(isNaN(cur)) cur = pages[0];
    var hi0 = pages[pages.length - 1];
    var first = pag.querySelector('.jdgm-paginate__first-page'), last = pag.querySelector('.jdgm-paginate__last-page');
    var L = last ? parseInt(last.dataset.page, 10) : NaN;
    if(isNaN(L)){
      var w = pag.closest ? pag.closest('.jdgm-rev-widg') : null;
      var n = w ? parseInt(w.getAttribute('data-number-of-reviews'), 10) : NaN, pp = parseInt(pag.dataset.perPage, 10);
      if(n > 0 && pp > 0){
        var capped = Math.ceil(n / pp) > 100, Lc = capped ? 100 : Math.ceil(n / pp);
        if(Lc > hi0 && $ && byNum[hi0]){
          var $c = $(byNum[hi0]).clone(true).removeClass('jdgm-curt').addClass('jdgm-paginate__last-page ss-synth')
            .attr({'data-page': String(Lc), 'aria-label': 'Page ' + Lc}).removeAttr('aria-current').text(String(Lc));
          $c.data('page', Lc); pag.appendChild($c[0]); last = $c[0]; L = Lc;
        } else L = capped ? Lc : Math.max(Lc, hi0);   /* over taket rendrer Judge.me 101, 102 … som ikke kan naas - de skjules av vinduet under */
      }
    }
    var lo = Math.max(1, cur - 1), hi = cur + 1;
    if(cur === 1) hi = 3;
    if(!isNaN(L)){ if(cur >= L) lo = Math.max(1, L - 2); hi = Math.min(hi, L); }
    else hi = Math.min(hi, hi0);
    pages.forEach(function(k){ byNum[k].classList.toggle('ss-hide', !(k >= lo && k <= hi) && k !== cur); });
    function ell(cls){ var e = document.createElement('span');
      e.className = 'jdgm-paginate__page ss-ellipsis ' + cls; e.textContent = '…'; return e; }
    if(first){ var F = parseInt(first.dataset.page, 10); if(isNaN(F)) F = 1;
      if(F < lo){ if(first.textContent !== String(F)) first.textContent = String(F); first.classList.add('ss-show');
        if(F < lo - 1) pag.insertBefore(ell('ss-ell-start'), first.nextSibling); }
      else first.classList.remove('ss-show'); }
    else if(lo > 1 && byNum[1]){ byNum[1].classList.remove('ss-hide'); if(lo > 2) pag.insertBefore(ell('ss-ell-mid'), byNum[1].nextSibling); }
    if(last && !isNaN(L)){
      if(L > hi){ if(last.textContent !== String(L)) last.textContent = String(L); last.classList.add('ss-show');
        if(L > hi + 1) pag.insertBefore(ell('ss-ell-end'), last); }
      else last.classList.remove('ss-show'); }
    else if(!isNaN(L) && L > hi && byNum[L]){ byNum[L].classList.remove('ss-hide'); if(L > hi + 1) pag.insertBefore(ell('ss-ell-mid'), byNum[L]); }
    var nx = pag.querySelector('.jdgm-paginate__next-page');
    if(nx){ if(nx.textContent.trim() !== '›') nx.textContent = '›'; nx.classList.toggle('ss-hide', !isNaN(L) && cur >= L); }
    var pv = pag.querySelector('.jdgm-paginate__prev-page'); if(pv && pv.textContent.trim() !== '‹') pv.textContent = '‹';
  }

  /* 7) masonry: hvert kort faar grid-row: span <hoyde+14>, grid-auto-flow:dense
        legger det i korteste kolonne. Kortene har align-self:start, saa
        gridRowEnd endrer IKKE kortets egen hoyde - ResizeObserveren under
        utloses derfor bare av ekte hoydeendringer (bilder som laster, tekst som
        oversettes, vindu som endrer bredde). Klassen ss-masonry settes forst
        naar minst ett kort er maalt, saa et ikke-maalt grid aldri overlapper. */
  var ro = (typeof ResizeObserver !== 'undefined') ? new ResizeObserver(function(){ schedule(); }) : null;
  function masonry(){
    var g = document.querySelector('.jdgm-rev-widg__reviews'); if(!g) return;
    var cards = g.querySelectorAll('.jdgm-rev'); if(!cards.length) return;
    var any = false;
    cards.forEach(function(c){
      var h = Math.ceil(c.getBoundingClientRect().height);
      if(h > 0){ var span = 'span ' + (h + 14); if(c.style.gridRowEnd !== span) c.style.gridRowEnd = span; any = true; }
      if(ro && !c.dataset.ssRo){ ro.observe(c); c.dataset.ssRo = '1'; }
    });
    if(ro && !g.dataset.ssRo){ ro.observe(g); g.dataset.ssRo = '1'; }
    if(any && !g.classList.contains('ss-masonry')) g.classList.add('ss-masonry');
  }

  /* 8) spraaknavn i oversett-knappen. Judge.me tagger norske anmeldelser 'nb' og rendrer navnet
        klientsiden med Intl.DisplayNames([maalspraak]).of('nb') -> «norskt bokmaal» paa .se, «bokmaal» paa
        .dk, «norsk bokmaal» paa .no (der er maalspraaket nb etter no->nb-mappingen i theme.liquid).
        Bytt til navnet for 'no' («norska», «norsk», ...). Nettleserens egne navn, ingen tabell per spraak.
        Maalspraaket regnes ut med samme uttrykk som widgeten bruker. Idempotent: etter bytte finnes ikke
        bokmaal-strengen lenger i knappen. Kun .jdgm-translate-button roeres. */
  function langNames(){
    var S = window.jdgmSettings || {};
    var target = (S.enable_multi_locales_translations && document.documentElement.lang)
                 || S.shop_locale || S.locale || document.documentElement.lang || 'en';
    var dn; try { dn = new Intl.DisplayNames([target], {type:'language'}); } catch(e){ return; }
    var bad, good; try { bad = dn.of('nb'); good = dn.of('no'); } catch(e){ return; }
    if(!bad || !good || bad === good) return;
    document.querySelectorAll('.jdgm-translate-button').forEach(function(b){
      if(b.textContent.indexOf(bad) !== -1) b.textContent = b.textContent.split(bad).join(good);
    });
  }

  /* 9) summary-teksten skal staa uten parentes paa egen linje («Basert paa 33 anmeldelser»). Teksten
        settes i Judge.me-admin per butikk; dette er sikkerhetsnettet om noen setter «(...)» tilbake.
        Idempotent: etter strippen er det ingen omsluttende parentes aa fjerne. */
  function summaryText(){
    document.querySelectorAll('.jdgm-rev-widg__summary-text').forEach(function(el){
      var t = el.textContent.trim();
      if(t.length > 2 && t.charAt(0) === '(' && t.charAt(t.length - 1) === ')' && el.children.length === 0){
        el.textContent = t.slice(1, -1).trim();
      }
    });
  }

  function run(){ i18n(); avg(); moveAi(); headerV2(); emptyState(); sortPlaceholder(); eagerImgs(); upgradeImgs(); untruncate(); numbers(); paginate(); masonry(); langNames(); summaryText(); }

  /* throttle (18.09.2026 - var en debounce som ble skjoevet for hver mutasjon: mens Judge.me lastet bilder og bygde om
     headeren ved ~2,0 s, ble headerV2 utsatt til alt var stille, 2,9-4,7 s. Naa kjoerer vi senest 80 ms etter den foerste
     mutasjonen i en bolge). Observeren settes paa pause mens vi selv endrer DOM, slik at vaare egne endringer ikke
     trigger nye kjoringer. */
  var OBS_OPTS = {childList:true, subtree:true, characterData:true}; /* ogsaa tekstendringer - Judge.me oversetter «Write a review» -> «SKRIV EN ANMELDELSE» sent, og setningsformen i headerV2 skal foelge */
  var timer = null, obs = null, busy = false;
  function schedule(){
    if(busy || timer) return;
    timer = setTimeout(function(){
      timer = null; busy = true;
      if(obs) obs.disconnect();
      try { run(); } catch(e) {}
      if(obs) obs.observe(document.documentElement, OBS_OPTS);
      busy = false;
    }, 80);
  }
  run();
  obs = new MutationObserver(schedule);
  obs.observe(document.documentElement, OBS_OPTS);
  document.addEventListener('click', function(){ setTimeout(schedule, 400); }, true);
})();
